import { useInstantSearch } from "react-instantsearch";
import styles from "../PLP-2.0/PlpFilter/plpFilter.module.scss";
import { useEffect } from "react";

const TotalCount = (props) => {
  // setting default values to the props in case not passed
  const {
    shouldRender = true,
    setTotalPages = () => { },
    isUsedForPagination = false,
    productsLengthPerPage = null,
    setTotalFetchedProducts = () => { },
    totalFetchedProducts = null,
    resetPagination = () => { }
  } = props

  const { results } = useInstantSearch();

  useEffect(() => {
    if (isUsedForPagination) {
      setTotalPages(Math.ceil(results.nbHits / productsLengthPerPage))
      setTotalFetchedProducts(results.nbHits)
      // used to reset the pagination params to start calculating from 1st page when results are changed
      if (totalFetchedProducts !== results.nbHits && totalFetchedProducts !== null) {
        resetPagination(1)
      }
    }

  }, [results])

  return (
    <div className="search-result-count-plp">
      <>
        {shouldRender ? (<div className={`x-small-sm x-small-md xx-small-xs`}>
          <span className={`ais-Stats-text`}> {results.nbHits} results</span>
        </div>) : (<></>)}
      </>
    </div>
  );
};

export default TotalCount;
